import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import { dataAttrs, testAttr } from 'Helpers/Testing';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';


const Layout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();

  const handleContinue = async () => {
    await onSubmit();
  };

  return (
    <>
      <MetaControlField
        attr={'title'}
        {...dataAttrs('risk-tolerance-title', resource, {
          [testAttr.dataType]: resource.attr('type'),
        })}
      />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={2}>
          <MetaControlField attr={'imageUrl'} />
          <MetaControlField attr={'subtitle'} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.meta().canPost() ? <FDPrimaryActionButton
          loading={saving}
          label={'Continue →'}
          onClick={handleContinue}
          {...dataAttrs('continue-btn', resource, {
            [testAttr.dataType]: resource.attr('type'),
          })}
        /> : null}
      </DialogActions>
    </>
  );
};

export default Layout;
